<script setup>
import { useSidebarStore } from '@/store/sidebar-store';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const sidebarStore = useSidebarStore();
const isDevelopment = import.meta.env.VITE_APP_ENV === 'development';

const footerStyle = computed(() => ({
    marginLeft: sidebarStore.isSidebarActive ? '22rem' : '0',
    maxWidth: sidebarStore.isSidebarActive ? 'calc(100% - 22rem)' : '100%',
    transition: 'margin-left 0.3s ease, max-width 0.3s ease' // transition 추가
}));

const goPrivacyTreat = () => {
    router.push('/privacytreat');
    //window.open('http://admin.rentbridge.co.kr/privacytreat/', '_blank');
};
</script>

<template>
    <div class="layout-footer" :style="footerStyle">
        <div class="footer-content">
            <div @click="goPrivacyTreat" class="custom-text">개인정보처리방침</div>
            <template v-if="isDevelopment">
                <a href="https://primevue.org/setup/" target="_blank" rel="noopener noreferrer" class="custom-text">PrimeVue</a>
                <a href="https://primevue.org/icons/" target="_blank" rel="noopener noreferrer" class="custom-text">icon</a>
                <a href="https://tailwindcss.com/docs/installation" target="_blank" rel="noopener noreferrer" class="custom-text">tailwind</a>
                <a href="https://vuejsexamples.com/" target="_blank" rel="noopener noreferrer" class="custom-text">vue3</a>
            </template>
        </div>
    </div>
</template>

<style scoped>
.layout-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem; /* 높이 고정 */
    min-height: 3rem; /* 최소 높이 (IE 호환성) */
    padding: 0 1rem; /* 좌우 패딩 */
    width: 100%;
    /* position, bottom, left, width, z-index 등은 그대로 유지 */
}

.footer-content {
    display: flex;
    flex-wrap: nowrap; /* 줄바꿈 없음 */
    justify-content: center; /* 가로 중앙 정렬 */
    align-items: center; /* 세로 중앙 정렬 */
    gap: 1rem; /* 요소 간 간격 */
    width: 100%; /* 너비 100% */
    max-width: 1200px; /* 최대 너비 (선택 사항) */
    padding: 0.5rem 0; /* 상하 패딩 */
    overflow-x: auto; /* 가로 스크롤 */
    overflow-y: hidden; /* 세로 스크롤 숨김 (선택 사항) */
    -ms-overflow-style: none; /* IE, Edge */
    scrollbar-width: none; /* Firefox */
}
.footer-content::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}

.custom-text {
    color: #b3b4b6;
    text-decoration: none;
    transition: text-decoration 0.2s ease-in-out;
    font-family: 'SCoreDream500';
    font-size: 0.85rem;
    cursor: pointer;
    margin: 0 0.5rem; /* 좌우 마진 */
    white-space: nowrap; /* 텍스트 줄바꿈 방지 */
    /* word-break 제거 */
}

.custom-text:hover {
    text-decoration: underline;
}
</style>
